import { Box, CircularProgress, Divider, IconButton, Skeleton, Typography, useTheme } from "@mui/material"
import BatchPredictionOutlinedIcon from '@mui/icons-material/BatchPredictionOutlined';
import { tokens } from "../../../../theme";

export const CustomManualInfoButton = ({ title, value, subinfo, iconColor, width, loadingInfoData, units }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  function checkNullOrUndefined(value) {
    if (value == null || value?.toString().includes("undefined")) {  // Checks for both null and undefined
      return false;
    }
    return true;
  }
  const isValidDateString = (dateString) => {
    /* CustomInfoButton.jsx:14 isValidDateString 2025-03-12 10:10:06 */
    // d-m-y h:m:s
    //const date = new Date(dateString);
    //convert to d-m-y h:m:s
    const formattedDate = dateString.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });

    /* dateString 15-04-2025 09:19:07
CustomManualInfoButton.jsx:21 formattedDate Invalid Date */
    return formattedDate?.toString() !== "Invalid Date" ? formattedDate : false
  };
  return <Box sx={{
    borderRadius: "10px",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: width,
    height: 50,
    backgroundColor: colors.redAccent[900],

  }}>
    {/* <IconButton
      aria-label="close"
      sx={{
        color: iconColor, // Replace this with your desired hex color,
        width: 25,
        height: 50
      }}
    >
      <BatchPredictionOutlinedIcon sx={{ width: 20, height: 20 }} />
    </IconButton> */}
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      width: width }}>
      <Box sx={{
        display: "flex", justifyContent: "center",
        flexDirection: "row",
        alignContent: "center",
        textAlign: "center",
        alignItems: "center",
      }}>

        <Typography sx={{ color: "#727681", fontSize: "12px" }}>
          {title} 
        </Typography>
        {checkNullOrUndefined(value) ? <Typography sx={{
          pl: 1, color: "#727681", fontSize: "12px"
        }}>
          <b>
            {value} {units}
          </b>
        </Typography> :
          <Typography sx={{ ml: 2 }} />
        }

      </Box>
      <Box sx={{
        flexDirection: "column",
        display: "flex",
        justifyContent: "center",
        color: "#727681",
        textAlign: "center",
      }}>
        <Typography sx={{ fontSize: "12px" }}>
          {isValidDateString(subinfo) ? isValidDateString(subinfo) : <Skeleton animation="wave" />
          }
        </Typography>
      </Box>
    </Box>



  </Box>
}

